<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon">
          <i class="pe-7s-note2 icon-gradient bg-mean-fruit"></i>
        </div>
        <div>
          Upload History
          <div class="page-title-subheading">History of all document uploads (payslips, form-16, joining letters, experience letters).</div>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3 card">
    <div class="card-body">
      <div *ngIf="!isAdmin" class="alert alert-warning" role="alert">
        You do not have permission to view upload history.
      </div>

      <div *ngIf="isAdmin">
        <div *ngIf="uploadHistoryErrorMessage" class="alert alert-danger" role="alert">{{ uploadHistoryErrorMessage }}</div>

        <div *ngIf="isLoadingUploadHistory" class="text-center text-muted py-4">Loading upload history...</div>

        <div *ngIf="!isLoadingUploadHistory && !uploadHistory.length && !uploadHistoryErrorMessage" class="text-center text-muted py-4">
          No upload history found.
        </div>

        <vio-table-v2
          *ngIf="!isLoadingUploadHistory && uploadHistory.length"
          [tableData]="uploadHistory"
          [tableConfig]="uploadHistoryTableConfig"
        ></vio-table-v2>
      </div>
    </div>
  </div>
</div>
